import React from "react";
import * as S from "./styles";

export const Banner: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.Mascote />
        <S.TextBanner>
          <S.Title className="light">Regulamento </S.Title>
          <S.Title className="bold">Para cupons</S.Title>
        </S.TextBanner>
      </S.Content>
    </S.Container>
  );
};
